import { Component, Renderer2 } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {
    AuthService,
    PageComponent,
    PageService,
    PageType,
    ParserService,
    SettingsService,
    WindowService,
    DocumentService,
} from '@gallaghercp/core-frontend';
import { ActivatedRoute, Router } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { tap } from 'rxjs';

@Component({
    selector: 'core-block-one-page',
    template: `
        <div class="page-loader text-center" [hidden]="!loading">
            <div class="loader"></div>
        </div>
        @if (page$ | async; as page) {
            <header class="navbar-top">
                <div
                    class="container--nav container--nav-vertical-logo"
                    [ngClass]="{
                        'container--nav-center': page.meta?.['headerAlign'] === 'center',
                        'container--nav-right': page.meta?.['headerAlign'] === 'right',
                    }"
                >
                    <div class="d-flex align-items-center">
                        <a
                            [core-analytics]="{ action: 'Home', category: 'TOP-NAV' }"
                            class="navbar-brand"
                            routerLink="/"
                        >
                            <!-- <img [alt]="page.meta.title + ' logo'" src="../../../../assets/img/gallagher-logo.svg" class="navbar-logo"> -->
                            <img
                                alt="logo"
                                [src]="clientLogo"
                                class="navbar-logo"
                                [ngStyle]="{
                                    '--max-logo-width': page.meta?.['logoWidth'],
                                    '--max-logo-height': page.meta?.['logoHeight'],
                                }"
                            />
                        </a>
                    </div>
                </div>
            </header>
            @for (block of page.widgets | orderBy: ['data.row', 'data.col']; track trackByFn($index, block)) {
                <core-block
                    [block]="block"
                    [ngStyle]="{
                        padding: block.data.padding,
                        block: block.data.margin,
                        '--color-primary': page.meta?.['primaryColor'],
                        '--text-color-against-color-primary': page.meta?.['textColorAgainstPrimary'],
                        '--secondary-color': page.meta?.['secondaryColor'],
                        '--text-color-against-color-secondary': page.meta?.['textColorAgainstsecondary'],
                        '--tertiary-color': page.meta?.['tertiaryColor'],
                        '--text-color-against-color-tertiary': page.meta?.['textColorAgainstTertiary'],
                        '--text-color-against-sub-header': page.meta?.['textColorSubHeader'],
                        '--color-heading': page.meta?.['textColorSubHeader'],
                        '--navigation-section-background': page.meta?.['navigationBackground'],
                        '--font-heading': page.meta?.['headerFont'],
                    }"
                    class="core-block-l1 {{
                        getBlockClassPosition(block, page.widgets[$index - 1]) + ' ' + getBlockClasses(block)
                    }}"
                >
                </core-block>
            }
            <core-one-page-footer [page]="page" [logo]="clientLogo"></core-one-page-footer>
        }
    `,
    standalone: false,
})
export class BlockOnePageComponent extends PageComponent {
    installModal?: BsModalRef;

    clientLogo = '/assets/img/gallagher-logo.svg';

    constructor(
        protected override route: ActivatedRoute,
        protected override router: Router,
        protected override pages: PageService,
        protected override titleService: Title,
        protected override metaTagService: Meta,
        protected override auth: AuthService,
        protected override parser: ParserService,
        protected override settings: SettingsService,
        protected override windowService: WindowService,
        protected override documentService: DocumentService,
        protected renderer: Renderer2,
    ) {
        super(
            route,
            router,
            pages,
            titleService,
            metaTagService,
            auth,
            parser,
            settings,
            windowService,
            documentService,
        );
    }

    override ngOnInit() {
        let pageUrl: string = window.location.hostname.replace(/^www\./, '').replace(/\./g, '-');
        if (pageUrl === 'localhost') {
            pageUrl = 'onepage-builtoncore-com';
        }

        this.page$ = this.pages.getPage(pageUrl).pipe(
            tap((page: PageType) => {
                if (page?.meta?.['pageIcon']) {
                    this.clientLogo = 'https://onepage.builtoncore.com/' + String(page.meta?.['pageIcon']);
                    this.titleService.setTitle(page.name);
                }
                // Marky Marks code didn't work on the root var for this - could be race cond?
                // putting here has got it working,
                if (page?.meta?.['navigationBackground']) {
                    const root = document.documentElement;
                    root.style.setProperty('--navigation-section-background', page.meta['navigationBackground']);
                }

                if (page?.meta?.['primaryColor']) {
                    this.settings.setPrimaryColor(page.meta['primaryColor']);
                }
                if (page?.meta?.['secondaryColor']) {
                    this.settings.setSecondaryColor(page.meta['secondaryColor']);
                }

                if (page?.meta?.['backToTopColor']) {
                    const style = this.renderer.createElement('style');
                    style.innerHTML = `
                        .back-to-top__link {
                          background: ${page.meta['backToTopColor']} !important;
                        }
                      `;
                    this.renderer.appendChild(document.head, style);
                }
                if (page?.meta?.['linkColor']) {
                    const style = this.renderer.createElement('style');
                    style.innerHTML = `
                        .link-primary {
                          color: ${page.meta['linkColor']} !important;
                          text-decoration-color: ${page.meta['linkColor']} !important;
                        }
                      `;
                    this.renderer.appendChild(document.head, style);
                }
            }),
        );
    }
}
